import React from 'react';
import OperationHeaderBanner from './OperationHeaderBanner';
import { OperationMS } from '../types';

interface OperationHeaderProps {
  operation: OperationMS;
  lotImage?: string;
}

// Banniere acheteur-MS V2 : rendu autonome (fork de SuiviHeader, sans prop source ni branches BC/BCI).
// Le statut/couleur/expiration sont calcules dans OperationHeaderBanner via le domaine operationStatus.
// Le titre suit le buffer d'edition live (operation.formulaire.nomOperation, alimente par le champ
// "Nom de l'operation" via patchFormulaire) et retombe sur la valeur persistee tant qu'aucune saisie.
const OperationHeader: React.FC<OperationHeaderProps> = ({ operation, lotImage }) => (
  <OperationHeaderBanner
    titre={operation.formulaire?.nomOperation ?? operation.nom ?? ''}
    sousTitre=""
    subtitle={`${operation.lot_technique?.id ?? ''} - ${operation.lot_technique?.nom ?? ''}, ${operation.id_lot_departement ?? ''} - ${operation.lot_departement?.departement?.nom ?? ''}`}
    operation={operation}
    backgroundImage={lotImage}
  />
);

export default OperationHeader;
